import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress, Icon, IconButton, Spacer, Stack, TextField, Typography, useSnackbar } from '@emburse/embark-core';
import { useCallback, useState } from 'react';
import { LaunchIcon } from '@emburse/embark-icons';
import VerticallyCenteredLayout from '../../components/Layouts/VerticallyCenteredLayout';
import { createExpenseReportForReportExecutive } from '../../api/expenseReport';
import { logger } from '../../util/logger';
function ReportExecutiveQa() {
    const { enqueueSnackbar } = useSnackbar();
    const [isRunning, setIsRunning] = useState(false);
    const [empId, setEmpId] = useState('');
    const onRunClick = useCallback(async (empIdToRunOn) => {
        setIsRunning(true);
        try {
            const { expenseReportId, expenseReportName, numberOfExpenses } = await createExpenseReportForReportExecutive(empIdToRunOn);
            const reportLink = `/ExpRptView.aspx?ID=${expenseReportId}`;
            enqueueSnackbar(`Created report "${expenseReportName}" and added ${numberOfExpenses} expenses`, {
                variant: 'success',
                action: (_jsx(Button, { color: "success", href: reportLink, children: "Go to report" }))
            });
        }
        catch (ex) {
            enqueueSnackbar(ex, { variant: 'error' });
            logger.error('Failed to create expense report for Report Executive', ex);
        }
        finally {
            setIsRunning(false);
        }
    }, [enqueueSnackbar]);
    return (_jsxs(VerticallyCenteredLayout, { children: [_jsxs(Stack, { spacing: 2, sx: { width: '100%', maxWidth: '900px' }, alignItems: "flex-start", children: [_jsx(Typography, { variant: "h4", children: "Report Executive Admin Page" }), _jsx(Typography, { children: "Creates an Expense Report for the current user and runs the new Report Executive logic on it" })] }), _jsx(Spacer, { size: 50 }), _jsxs(Stack, { direction: "row", spacing: 2, sx: { width: '100%', maxWidth: '900px' }, children: [_jsx(TextField, { value: empId, label: "Employee ID", onChange: (e) => setEmpId(e.target.value) }), _jsx(IconButton, { size: "small", "aria-label": "run", onClick: () => onRunClick(parseInt(empId, 10)), children: isRunning ? _jsx(CircularProgress, { size: 20 }) : _jsx(Icon, { iconUrl: LaunchIcon }) })] })] }));
}
export default ReportExecutiveQa;
